module.exports = __webpack_public_path__ + "static/media/meme_8.5e6c0a83.jpg";